import React from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

// https://github.com/fkhadra/react-toastify
const Toast: React.FC = () => {
	return (
		<div>
			<ToastContainer
				position="top-right"
				autoClose={4000}
				draggable={false}
				hideProgressBar={false}
				newestOnTop={true}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				pauseOnHover
			/>
		</div>
	);
};

export default Toast;
